var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$router.push('/')}}},[_vm._v("Início")])]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }